import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockOrderDocs = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderDocsRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderDocsResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsRequest1.xml'} title={t('Пример запроса') + ' ' + t('Создание задания')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsResponse1.xml'} title={t('Пример успешного ответа') + ' ' + t('Создание задания')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsRequest2.xml'} title={t('Пример запроса') + ' ' + t('Проверка статуса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsResponse2.xml'} title={t('Пример успешного ответа') + ' ' + t('Проверка статуса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsRequest3.xml'} title={t('Пример запроса') + ' ' + t('Получение результата')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsResponse3.xml'} title={t('Пример успешного ответа') + ' ' + t('Получение результата')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderDocsResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockOrderDocs;